/*
 *  Project: dux - sticky table header
 *  Description: fix table header while scrolling the content
 *  Author: bwin
 */

;(function ( $, window, document, undefined ){

    var pluginName = 'dv_stickyth',
        _self,
        _win = $( window ),
        scrollbarWidth,
        defaults = {
            topTarget: '.resource-header',
            content: '.resource-content'
        };

    var _waitForFinalEvent = (function (){

        var timers = {};

        return function ( callback, ms, uniqueId ){
            if ( !uniqueId ) {
                uniqueId = "Don't call this twice without a uniqueId";
            }
            if ( timers[ uniqueId ] ) {
                clearTimeout( timers[ uniqueId ] );
            }
            timers[ uniqueId ] = setTimeout( callback, ms );
        };
    })();

    function Plugin( element, options ){

        _self = this;
        scrollbarWidth = this._getScrollBarSize();

        this.element = element;
        this.$element = $( element );

        this.options = $.extend( {}, defaults, options );

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
        this._addClippingMask();
        this._addScrollbar();
        this._resizeFixed( this._calcScrollbar );
    }

    $.extend( Plugin.prototype, {
        init: function (){

            var $clipper = this.$element.children( '.table-clip' );
            $clipper.remove();

            var $table = this.$element.children( 'table' ); // regular table
            var $content = $( this.options.content ); // content wrapper

            // fixed table header
            var $tableFixed = $( '<table />' )
                .attr( {
                    'class': $table.prop( 'class' ),
                    'id': 'th-' + this._setUniqueId()
                } )
                .addClass( 'table-clip-head' );

            // Prepend fixed table header
            // as first element in selector
            this.$element.prepend( $tableFixed );

            // clone regular table header and
            // appent it to the fixed table header
            // and fill th's background with body color
            $tableFixed.append( this.$element.find( 'thead' ).clone() );

            // wrap fixed table header with
            // a clipping (mask) element
            $tableFixed.wrap( '<div class="table-clip">' );

            // Scrolling the responsive table
            // and moving fixed scrollbar identically
            this.$element.on( 'scroll', function (){

                var $clipper = $( this ).children( '.table-clip' ),
                    $tableFixed = $clipper.children( '.table-clip-head' ),
                    $scrollBar = $tableFixed.siblings( '.scrollbar-wrapper' ),
                    leftInit = $( this ).offset().left;

                // remove 'left' css property
                $tableFixed.css( 'left', '' );

                // move (offset) fixed header on scrolling
                var scrollLeft = $( this ).scrollLeft();

                $tableFixed.offset( {
                    left: -scrollLeft + leftInit
                } );

                $scrollBar.scrollLeft( $( this ).scrollLeft() );
            } );

            // Do things on content vertical scroll
            $content.on( 'scroll', function (){

                // Hide and show fixed table header
                // depending on current offset
                var $clipper = $( '.table-clip' );

                $clipper.each( function ( idx, clip ){

                    var $tableFixed = $( clip ).children( '.table-clip-head' ),
                        leftInit = $( clip ).parent().offset().left,
                        $top = _self._getTopTarget(), // top target element
                        topHeight = $top.outerHeight(),
                        tableTop = $( clip ).siblings( 'table' ).offset().top;

                    if ( tableTop <= topHeight + $top.offset().top ) {

                        $( clip ).removeClass( 'hidden' );

                        var scrollLeft = $( clip ).parent().scrollLeft();

                        // move (offset) fixed header on scrolling
                        $tableFixed.offset( {
                            left: -scrollLeft + leftInit
                        } );

                        _self._calcScrollbar();

                    }
                } );
            } );

            // Run after resizing the window
            var states = [];
            _win.on( 'resize', function (){
                // clear array content
                states.length = 0;

                var $clipper = $( '.table-clip' );

                // add visibility state of each table to array
                $clipper.each( function ( idx, clip ){
                    states.push( $( clip ).attr( 'id' ), $( clip ).is( ':visible' ) );
                } );

                // wait for finished resize
                // event, to recalculate offsets
                _waitForFinalEvent( function (){

                    if ( $.inArray( true, states ) === -1 ) return false;
                    _self._resizeFixed( _self._calcScrollbar );

                }, 10, "recalculate table-header-fixed offsets" );

            } );

        },
        _getTopTarget: function (){

            if ( this.$element.attr( 'data-top-target' ) ) {
                return $( this.$element.attr( 'data-top-target' ) );
            }

            return $( this.options.topTarget );
        },
        _addClippingMask: function (){

            var $clipper = $( '.table-clip' ); // Clipping element

            // Handle each clipping element
            $clipper.each( function (){

                // set identifier
                $( this ).attr( 'id', 'tc-' + _self._setUniqueId() );

                // Set initial height of the clip
                // equal to the regular table
                _self._calcClippingMask();
            } );

        },
        _calcClippingMask: function (){
            // Calculate clipping mask
            var $clipper = $( '.table-clip' );

            $clipper.each( function ( idx, clip ){

                var curHeight = $( clip ).parent().outerHeight();

                $( clip ).outerHeight( curHeight - scrollbarWidth );
            } );
        },
        _calcFixedTopOffset: function ( callback ){
            // Set fixed table header offset in
            // relation to resource-header height
            var $tableFixed = $( '.table-clip-head' ),
                $top = this._getTopTarget();

            $tableFixed
                .css( 'top', '' )
                .offset( {
                    top: $top.offset().top + $top.outerHeight()
                } );

            callback();
        },
        _addScrollbar: function (){

            var $tableFixed = this.$element.find( '.table-clip-head' ),
                $top = this._getTopTarget(),
                $content = $( this.options.content );

            // fixed scrollbar
            var $scrollBar = $( '<div/>' )
                .attr( 'id', 'sb-' + this._setUniqueId() )
                .addClass( 'scrollbar-wrapper' )
                .outerHeight( scrollbarWidth )
                .html( '&nbsp;' );

            // fixed scrollbar handle to lay
            // above the fixed scrollbar
            var $scrollHandle = $( '<div/>' )
                .attr( 'id', 'sh-' + this._setUniqueId() )
                .addClass( 'scrollbar-handle' );


            // Add fixed scrollbar before fixed table
            $tableFixed.before( $scrollBar );

            // Offset the scrollbar to the
            // bottom of content area
            $scrollBar.append( $scrollHandle ).offset( {
                top: $content.outerHeight() + $top.outerHeight() - scrollbarWidth
            } );

            // Scroll regular scrollbar when
            // moving the fixed bar from left to right

            $scrollBar.on( 'scroll', function (){

                var $clipper = $( this ).parent();

                $clipper.parent().scrollLeft( $( this ).scrollLeft() );
            } );
        },
        _calcScrollbar: function (){

            // Resize and hide the fixed scrollbar
            // if scrollbar is needless

            // Remember current scroll position
            var $clipper = $( '.table-clip' );

            $clipper.each( function ( idx, clip ){

                var curScrollPos = $( clip ).parent().scrollLeft(),
                    $content = $( _self.options.content ),
                    $scrollBar = $( clip ).children( '.scrollbar-wrapper' ),
                    $scrollHandle = $scrollBar.children( '.scrollbar-handle' ),
                    $table = $( clip ).siblings( 'table' ),
                    curWidth = $( clip ).parent().innerWidth();

                $scrollBar.css( {
                    top: $content.position().top + $content.outerHeight( true ) - scrollbarWidth
                } )
                    .innerWidth( curWidth );

                $scrollHandle.innerWidth( $table.innerWidth() );

                // set scroll position as before
                $scrollBar.scrollLeft( curScrollPos );
            } );
        },
        _resizeFixed: function ( callback ){

            // match width of fixed header to regular table header
            var $clipper = $( '.table-clip' );

            $clipper.each( function (){

                var $table = $( this ).siblings( 'table' ),
                    $tableFixed = $( this ).children( '.table-clip-head' );

                $tableFixed.outerWidth( $table.outerWidth() );

                $.each( $table.find( 'th' ), function ( idx ){
                    $tableFixed.find( 'th' ).eq( idx ).width( $( this ).width() )
                } );

            } );

            this._calcFixedTopOffset( this._calcClippingMask );

            callback();
        },
        _setUniqueId: function ( id ){
            if ( !id ) {
                return Math.round( new Date().getTime() + (Math.random() * 100) );
            }
            return id;
        },
        _getScrollBarSize: function (){

            // Calculate the width of the
            // browser's scrollbar
            var $outer = $( '<div>' ).css( {
                    visibility: 'hidden',
                    width: 100,
                    overflow: 'scroll'
                } ).appendTo( 'body' ),
                widthWithScroll = $( '<div>' ).css( { width: '100%' } ).appendTo( $outer ).outerWidth();

            $outer.remove();

            return 100 - widthWithScroll;
        },
        refresh: function (){

            this.init();
            this._addClippingMask();
            this._addScrollbar();
            this._resizeFixed( this._calcScrollbar );

        }
    } );

    $.fn[ pluginName ] = function ( options ){
        var args = arguments;

        if ( options === undefined || typeof options === 'object' ) {

            return this.each( function (){

                if ( !$.data( this, 'plugin_' + pluginName ) ) {
                    $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
                }

            } );

        } else if ( typeof options === 'string' && options[ 0 ] !== '_' && options !== 'init' ) {

            var returns;

            this.each( function (){

                var instance = $.data( this, 'plugin_' + pluginName );

                if ( instance instanceof Plugin && typeof instance[ options ] === 'function' ) {
                    returns = instance[ options ].apply( instance, Array.prototype.slice.call( args, 1 ) );
                }

                if ( options === 'destroy' ) {
                    $.data( this, 'plugin_' + pluginName, null );
                }

            } );

            return returns !== undefined ? returns : this;
        }
    };

})( jQuery, window, document );

;(function ( $, window, document, undefined ){

    // Select elements with certain css-class
    // data-attributes help to style selection
    $( function (){
        $( '.table-header-fixed' ).each( function (){

            var $this = $( this ),
                options = {
                    'topTarget': $this.attr( 'data-top-target' ),
                    'content': $this.attr( 'data-content' )
                };

            $this.dv_stickyth( options );
        } );
    } );
})( jQuery, window, document );
